<p>vehicles-realtime-view works!</p>
